export default __webpack_public_path__ + "static/media/Karishma.46611a74.jpg";